interface LocationInput {
  latitude?: number | null;
  lat?: number | null;
  longitude?: number | null;
  lng?: number | null;
}

export function distanceInMiles(point1?: LocationInput | null, point2?: LocationInput | null): number | null {
  if (!point1 || !point2) return null;
  const lat1 = point1.latitude ?? point1.lat;
  const lon1 = point1.longitude ?? point1.lng;
  const lat2 = point2.latitude ?? point2.lat;
  const lon2 = point2.longitude ?? point2.lng;

  if (!lat1 || !lon1 || !lat2 || !lon2) return null;
  const R = 3958.8; // Earth's radius in miles
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c;
  return distance;
}

const WALKING_SPEED_MPH = 3.1; // Average walking speed
const DRIVING_SPEED_MPH = 30; // Average city driving speed
export const WALKING_THRESHOLD = 0.8; // Switch to driving time if distance > 0.8 miles

export const getTravelDistance = (miles: number) => {
  if (miles <= WALKING_THRESHOLD) {
    const minutes = Math.round((miles / WALKING_SPEED_MPH) * 60);
    return { minutes, isWalkableDistance: true, count: 1 };
  } else {
    const minutes = Math.round((miles / DRIVING_SPEED_MPH) * 60);
    return { minutes, isWalkableDistance: false, count: 2 };
  }
};

export const getWalkingAndDrivingDistance = (miles: number) => {
  return {
    walking: Math.round((miles / WALKING_SPEED_MPH) * 60),
    driving: Math.round((miles / DRIVING_SPEED_MPH) * 60),
  };
};

function toRadians(degrees: number): number {
  return (degrees * Math.PI) / 180;
}
